var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowTri(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.892 3.58983L22.418 20.0898C22.5057 20.2418 22.5519 20.4143 22.5519 20.5898C22.552 20.7654 22.5057 20.9378 22.418 21.0898C22.3302 21.2418 22.204 21.3681 22.052 21.4558C21.9 21.5436 21.7275 21.5898 21.552 21.5898H2.49997C2.32444 21.5898 2.152 21.5436 1.99998 21.4558C1.84797 21.3681 1.72173 21.2418 1.63397 21.0898C1.5462 20.9378 1.5 20.7654 1.5 20.5898C1.5 20.4143 1.54621 20.2418 1.63397 20.0898L11.16 3.58983C11.2477 3.43782 11.374 3.3116 11.526 3.22384C11.678 3.13608 11.8504 3.08987 12.026 3.08987C12.2015 3.08987 12.3739 3.13608 12.526 3.22384C12.678 3.3116 12.8042 3.43782 12.892 3.58983ZM4.23197 19.5898H19.82L12.027 6.08983L4.23197 19.5898ZM11.026 16.5898H13.026V18.5898H11.026V16.5898ZM11.026 9.58983H13.026V14.5898H11.026V9.58983Z",
    fill: "#FF9932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowTri);
export default __webpack_public_path__ + "static/media/Yellow_Tri.9c8740d743b75beca48f8e505b4dc2b8.svg";
export { ForwardRef as ReactComponent };